import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "content"]

    connect() {
        this.update()
    }

    update() {
        if (this.checkboxTarget.checked) {
            this.contentTarget.classList.remove("hidden")
            this.contentTarget.classList.add("block")
        } else {
            this.contentTarget.classList.add("hidden")
            this.contentTarget.classList.remove("block")
        }
    }
}
